import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';


import {
    manageEntitlements,
    manageEntitlementsHeader,
    manageEntitlementsTitle,
} from '../manage-entitlements.module.styl';

type Props = {
    title: string,
    children: React.ReactNode,
    buttonsBlock: React.ReactNode,
    subtitle?: string,
};

export const ManageEntitlementsPage = ({children, title, subtitle, buttonsBlock}: Props) => {
    return (
        <div className={manageEntitlements}>
            <StickyElement className={manageEntitlementsHeader}>
                <div className={manageEntitlementsTitle}>
                    <StepHeader title={title} subTitle={subtitle}/>
                    <Group>{buttonsBlock}</Group>
                </div>
            </StickyElement>
            {children}
        </div>
    );
};
